module.exports = __webpack_public_path__ + "img/stock4.4024d913.png";